import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectOverviewKpis() {
  const kpis = [
    { label: 'Tiến độ tổng thể', value: '45%', subValue: 'Đang thực hiện', icon: 'ri-pie-chart-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
    { label: 'Công việc', value: '32 / 78', subValue: 'Hoàn thành', icon: 'ri-task-line', color: 'text-blue-600', bg: 'bg-blue-50' },
    { label: 'Chi phí thực tế', value: '12.850.000.000', subValue: 'VND', icon: 'ri-money-dollar-box-line', color: 'text-purple-600', bg: 'bg-purple-50' },
    { label: 'Giá trị đã thanh toán', value: '8.540.000.000', subValue: 'VND', icon: 'ri-refund-line', color: 'text-orange-600', bg: 'bg-orange-50' },
    { label: 'Còn lại phải thanh toán', value: '20.110.000.000', subValue: 'VND', icon: 'ri-hand-coin-line', color: 'text-amber-600', bg: 'bg-amber-50' },
    { label: 'Ngày còn lại', value: '92', subValue: 'ngày', icon: 'ri-calendar-todo-line', color: 'text-rose-600', bg: 'bg-rose-50' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {kpis.map((kpi, i) => (
        <div key={i} className="rounded-md bg-white p-3 space-y-2 border border-slate-100 flex flex-col group hover:border-slate-200 transition-all active:scale-[0.98] cursor-pointer">
          <div className="flex items-center gap-2">
            <div className={cn("p-2 rounded-md flex items-center justify-center shrink-0", kpi.bg, kpi.color)}>
              <i className={cn(kpi.icon, "text-lg")} />
            </div>
            <div className="flex flex-col min-w-0 flex-1">
              <span className="sm:text-sm text-xs font-normal text-slate-500 truncate">{kpi.label}</span>
              <div className="flex items-baseline gap-1 mt-0.5">
                <span className={cn("text-xl font-normal tracking-tight", kpi.color)}>{kpi.value}</span>
              </div>
            </div>
          </div>
          <div className="pt-2 border-t border-slate-50 flex items-center justify-between">
            <span className="sm:text-sm text-xs font-normal text-slate-500">{kpi.subValue}</span>
            <div className="flex items-center gap-1">
              <div className="h-1 w-12 rounded-full bg-slate-100 overflow-hidden">
                <div className={cn("h-full rounded-full", kpi.color.replace('text', 'bg'))} style={{ width: '45%' }} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
